export const Types = {
  Text: 'text',
  Number: 'number',
  Monetary: 'monetary',
  Succession: 'succession',
  Date: 'date',
  Skill: 'skill',
  PositionShortlist: 'position-shortlist',
  Array: 'array'
}

/**
 * Normalizes a field name for duplicate detection only. Never use this to derive a
 * formula variable — formulaFriendlyName() is the only source of truth there.
 *
 * This is deliberately stricter than formulaFriendlyName(): it lowercases, trims and
 * collapses any run of separators, so it flags everything formulaFriendlyName() would
 * turn into the same variable ("Cost Center", "cost-center", "Cost_Center") plus names
 * that merely look identical to a human ("Cost  Center", "Cost\tCenter"). Both classes
 * are duplicates worth blocking, and erring toward stricter only ever rejects a name
 * the user can trivially reword.
 */
export function normalizedFieldName(name) {
  return String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '_')
}

/**
 * @returns {object|null} The existing field whose name collides with `name`, or null.
 */
export function findFieldNameConflict(name, fields, { excludeId = null } = {}) {
  const normalized = normalizedFieldName(name)
  if (!normalized) return null

  return (
    (fields || []).find(
      (field) => field?.id !== excludeId && normalizedFieldName(field?.name) === normalized
    ) || null
  )
}
